export const getActionButtonRawStyles = () => ({
  root: {
    borderRadius: 999,
    fontSize: 13,
    fontStyle: 'normal',
    fontWeight: 400,
    borderWidth: 0,
    margin: 6,
    backgroundColor: 'rgb(255,255,255,0.2)',
  },
});
